// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CHzN","newExpiryDate":"styles_newExpiryDate__3KSu4","footer":"styles_footer__ksXQk"};